import React from 'react';
import socialProofMobile0 from '../../assets/images/socialProofMobile0.webp';
import socialProofMobile1 from '../../assets/images/socialProofMobile1.webp';
import socialProofMobile2 from '../../assets/images/socialProofMobile2.webp';
import socialProofMobile3 from '../../assets/images/socialProofMobile3.webp';
export const SocialProofMobileSvg = () => /*#__PURE__*/React.createElement("svg", {
  width: "343px",
  height: "407px",
  viewBox: "0 0 328 363",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, /*#__PURE__*/React.createElement("image", {
  href: socialProofMobile0,
  x: "0",
  y: "0",
  width: "120",
  height: "65.2632",
  preserveAspectRatio: "xMidYMid slice"
}), /*#__PURE__*/React.createElement("image", {
  href: socialProofMobile1,
  x: "219",
  y: "329",
  width: "133.327",
  height: "72.4248",
  preserveAspectRatio: "xMidYMid slice"
}), /*#__PURE__*/React.createElement("image", {
  href: socialProofMobile2,
  x: "241",
  y: "12",
  width: "140.735",
  height: "77.3628",
  preserveAspectRatio: "xMidYMid slice"
}), /*#__PURE__*/React.createElement("image", {
  href: socialProofMobile3,
  x: "18",
  y: "307",
  width: "124.915",
  height: "66.4604",
  preserveAspectRatio: "xMidYMid slice"
}));
//# sourceMappingURL=SocialProofMobileSvg.js.map